<app-list-editor [list]="keys()"
                 i18n-placeholder
                 placeholder="New theme name..."
                 (onAdd)="addTheme($event)"
                 (onRemove)="removeTheme($event)"
                 (selected)="edit($event)" />
@for (theme of keys(); track theme) {
  @if (theme === selectedTheme() && themes(); as group) {
    <app-code [group]="group"
              language="css"
              [fieldName]="theme" />
  }
}
